export default function LoadingProjectsThumb() {
  return (
    <section className='grid grid-cols-1 lg:grid-cols-4 md:grid-cols-3 gap-5'>
      {[0, 0, 0, 0, 0, 0, 0, 0].map((_, i) => (
        <div key={i} className='my-2 w-auto shadow-md rounded-md relative'>
          <div className='animate-pulse'>
            <div className='bg-neutralColor-light h-64 w-full'></div>
            <div className='p-2 bg-white'>
              <div className='h-4 bg-neutralColor-light rounded w-1/4 my-2'></div>
              <div className='space-y-2'>
                <div className='h-4 bg-neutralColor-light rounded mb-2'></div>
              </div>
              <div className='space-y-2'>
                <div className='h-4 bg-neutralColor-light rounded w-2/3 mb-2'></div>
              </div>
            </div>
          </div>
        </div>
      ))}
    </section>
  );
}
